import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, HostListener,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CommonFieldService} from "../../../../../services/common/common-field.service";
import {ClearingAllocationService} from "../../../../../services/clearing/clearing-allocation.service";
import {Order} from "../../../../../model/clearing/order";
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {FormFieldGroupConfig} from "../../../../../model/api/form-field-group-config";
import {CcFormDialogComponent} from "../../../../../crystal-elements/form-dialog/cc-form-dialog.component";
import {Trade} from "../../../../../model/clearing/trade";
import {FormFieldConfig} from "../../../../../model/api/form-field-config";
import {ExchangeOverride} from "../../../../../model/clearing/allocation/exchange-override";
import {FieldRecord} from "../../../../../model/api/field-record";
import {Contract} from "../../../../../model/exchange/contract";
import {FieldRequest} from "../../../../../model/api/field-request";
import {DecimalPipe} from "@angular/common";
import {ExchangeContractService} from "../../../../../services/exchange/exchange-contract.service";
import TYPE = FormFieldConfig.TYPE;
import Side = Trade.Side;
import {AppConfigService} from "../../../../../services/app-config.service";

@Component({
  selector: 'app-clearing-exchange-aps-override-form',
  templateUrl: './exchange-aps-override-form.component.html',
  // styleUrls: ['../split-allocation-form-base.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExchangeApsOverrideFormComponent extends CcBaseComponent {

  transPartKey: string = 'clearing.order';

  formLoading: boolean = false;

  formSubmitted: boolean = true;

  formConfig: FormFieldGroupConfig[] = [];

  dialogFormTitle: string = '';

  formRecord: any = {exchangeOverrides: []};

  loadingProgressValue: number = 0;
  dialogFormVisible: boolean = false;

  @Output()
  onSavedForm = new EventEmitter<any>();

  @ViewChild('ccAllocationSplitFormDialog')
  ccFormDialog: CcFormDialogComponent;

  dataToLoadCount: number = 2;

  significantOrders: Order[] = [];

  contracts: Contract[] = [];
  currentContractsRequest: string[] = undefined;
  currencies: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              protected appConfigService: AppConfigService,
              protected allocationService: ClearingAllocationService,
              protected exchangeContractService: ExchangeContractService,
              protected commonFieldService: CommonFieldService,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private decimalPipe: DecimalPipe) {
    super(cdref, messageService, translateService);
  }

  protected initConfigs() {
    super.initConfigs();
    this.refreshConfig();
    this.dialogFormTitle = this.getTranslation('page.' + this.transPartKey + '.table.exchange_aps_override');
  }


  public loadData() {
    // init data
    this.loadingProgressValue = 0;

    this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.currencies = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.refreshFieldData();
    });

    this.filterContracts();
  }

  protected filterContracts() {
    if (this.formRecord && this.formRecord.exchangeOverrides && this.formRecord.exchangeOverrides.length > 0) {
      const contractIdParts = [];
      this.formRecord.exchangeOverrides.forEach(exchangeOverride => {
        const contractIdPart: string = this.exchangeContractService.getContractIdPart(exchangeOverride.orders[0]);
        if (!contractIdParts.includes(contractIdPart)) contractIdParts.push(contractIdPart);
      });
      if (!this.currentContractsRequest
        || JSON.stringify(this.currentContractsRequest) != JSON.stringify(contractIdParts)) {
        this.currentContractsRequest = contractIdParts;
        this.exchangeContractService.getForIdParts(contractIdParts).subscribe(apiValidation => {
          if (apiValidation.success) {
            this.contracts = apiValidation.item;
            this.refreshFieldData();
          } else {
            this.errorMessage(apiValidation.message);
          }
        });
      } else {
        this.refreshFieldData();
      }
    } else {
      this.contracts = []
      this.refreshFieldData();
    }
  }

  protected refreshConfig() {

    this.formConfig = [
      {
        // group: 'order_to_override',
        group: '',
        fields: [
          {
            field: 'exchangeOverrides',
            required: true,
            filter: true,
            column: 12,
            type: TYPE.TABLEFORMFIELD,
            // validate: record => this.validateSplits(record),
            richFieldConfig: {
              // canDelete: formRecords => this.canDeleteSplit(formRecords),
              // canAdd: formRecords => this.canAddSplit(formRecords),
              // addNew: formRecords => this.addSplit(formRecords),
              fields: [
                {
                  group: '',
                  fields: [
                    {
                      field: 'reference',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].reference
                    },
                    {
                      field: 'side',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].side
                    },
                    {
                      field: 'volume',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) =>
                        record.orders.reduce((previousValue, currentValue) => previousValue + currentValue.volume, 0)
                    },
                    {
                      field: 'contractCode',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].contractCode
                    },
                    {
                      field: 'maturity',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].maturity
                    },
                    {
                      field: 'callPut',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].callPut
                    },
                    {
                      field: 'strike',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].strike
                    },
                    {
                      field: 'avgPriceGroupId',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].avgPriceGroupId
                    },
                    {
                      field: 'avgPrice',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].avgPrice
                    },
                    {
                      field: 'avgRndPrice',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].avgRndPrice
                    },
                    {
                      field: 'avgPriceResidual',
                      column: 1,
                      type: TYPE.NONE,
                      icon: (id, record) => this.getColorClass(record),
                      iconValue: (value, record) => record.orders[0].avgPriceResidual
                    },
                    // {
                    //   field: 'overrideAvgPrice',
                    //   column: 1,
                    //   type: TYPE.NONE,
                    //   icon: (id, record) => this.getColorClass(record),
                    //   iconValue: (value, record) => (record.orders[0].overrideAvgPrice.overrideAvgPrice == -99999 ?
                    //     0 : record.orders[0].overrideAvgPrice.overrideAvgPrice)
                    // },
                    {
                      field: 'overridePrice',
                      column: 2,
                      fractionDigits: (record) => {
                        if (record && record.orders && record.orders.length > 0) {
                          const currentContract = this.getContract(record.orders[0]);
                          if (currentContract) {
                            return currentContract && currentContract.pricePrecision.toString().includes('.')
                              ? currentContract.pricePrecision.toString().split(".")[1].length : 0;
                          }
                        }
                        return 0;
                      },
                      type: TYPE.DECIMAL,
                      // input: (event, event2) => {
                      //   const currentContract = this.getContract(event2.orders[0]);
                      //   if (currentContract) {
                      //     const contractMaxDecimalPlaces: number = currentContract && currentContract.pricePrecision.toString().includes('.')
                      //       ? currentContract.pricePrecision.toString().split(".")[1].length : 0;
                      //     const valueDecPlaces: number = event2.overridePrice && event2.overridePrice.toString().includes('.')
                      //       ? event2.overridePrice.toString().split(".")[1].length : 0;
                      //     console.log("-------> ### event " + JSON.stringify(event2.overridePrice));
                      //     console.log("-------> ### contractMaxDecimalPlaces " + JSON.stringify(contractMaxDecimalPlaces));
                      //     console.log("-------> ### valueDecPlaces " + JSON.stringify(valueDecPlaces));
                      //     if (valueDecPlaces > contractMaxDecimalPlaces) {
                      //       console.log("-------> ### new value " + Math.trunc(event2.overridePrice * (Math.pow(10, contractMaxDecimalPlaces))) / (Math.pow(10, contractMaxDecimalPlaces)));
                      //       event2.overridePrice = Math.trunc(event2.overridePrice * (Math.pow(10, contractMaxDecimalPlaces))) / (Math.pow(10, contractMaxDecimalPlaces));
                      //       // event.originalEvent.stopPropagation();
                      //       //   this.refreshFieldData();
                      //     }
                      //   }
                      // }
                    }]
                },
              ]
            }
          },
        ]
      },
      {
        fields: [
          {
            column: 2,
            type: TYPE.NONE,
            leftButton: {
              icon: 'fa-solid fa-rotate-left',
              class: 'p-button-warning',
              label: this.getTranslation('page.' + this.transPartKey + '.form.button.reset'),
              command: event => this.resetForm()
            },
          },
          {
            column: 2,
            type: TYPE.NONE,
          },
          {
            column: 2,
            type: TYPE.NONE,
            class: 'form-info-right',
            icon: id => '',
            iconValue: (value, record) => this.getTranslation('page.' + this.transPartKey + '.form.global_residual') + ':'
          },
          {
            column: 2,
            type: TYPE.NONE,
            icon: id => '',
            iconValue: (value, record) => this.getGlobalResidual()
          },
          {
            column: 2,
            type: TYPE.NONE,
          },
          {
            column: 2,
            type: TYPE.NONE,
            leftButton: {
              icon: 'fa-solid fa-hand-sparkles',
              class: 'p-button-success',
              label: this.getTranslation('page.' + this.transPartKey + '.form.button.optimize_aps'),
              command: event => this.optimizeAps()
            }
          }]
      }
    ];
  }

  private getColorClass(record) {
    return record.orders[0].side === Side.BUY ? 'form-info-green' : 'form-info-red';
  }

  closeDialogForm(): void {
    this.dialogFormVisible = false;
    this.markForCheck();
  }

  public refreshFieldData(): void {
    this.loadingProgressValue += 100 / this.dataToLoadCount;
    if (this.loadingProgressValue >= 100) {
      this.refreshConfig();
      this.ccFormDialog.reloadFieldValueMap();
      this.cdref.detectChanges();
    }
  }

  public open(orders: Order[], exchangeOverrides: ExchangeOverride[] = undefined): void {
    this.loadingProgressValue = 0;
    this.significantOrders = orders;
    this.loadExchangeOverrides(this.significantOrders, exchangeOverrides);
    this.loadData();

    this.dialogFormVisible = true;
    this.markForCheck();
  }

  private loadExchangeOverrides(orders: Order[], exchangeOverrides: ExchangeOverride[] = undefined, defaultOverrideUndefined: boolean = true) {
    if (!exchangeOverrides) {
      exchangeOverrides = [];
      orders.forEach(order => {
        let exchangeOverride = exchangeOverrides.find(exchangeOverride => {
            const firstOrder = exchangeOverride.orders[0];
            return firstOrder.owner == order.owner
              && firstOrder.exchangeCode == order.exchangeCode
              && firstOrder.reference == order.reference
              && firstOrder.contractCode == order.contractCode
              && firstOrder.callPut == order.callPut
              && firstOrder.maturity == order.maturity
              && firstOrder.strike == order.strike
              && firstOrder.side == order.side
              && firstOrder.avgPriceGroupId == order.avgPriceGroupId
          }
        );
        if (!exchangeOverride) {
          exchangeOverride = {overridePrice: 0, orders: []};
          exchangeOverrides.push(exchangeOverride);
        }

        // //fix override value XXXXX.XX000001
        // if (order) {
        //   const currentContract = this.getContract(order);
        //   if (currentContract) {
        //     const precision: number = currentContract && currentContract.pricePrecision.toString().includes('.')
        //       ? currentContract.pricePrecision.toString().split(".")[1].length : 0;
        //     if (precision > 0) {
        //       console.log(order.overrideAvgPrice);
        //       console.log(this.decimalPipe.transform(order.overrideAvgPrice, '1.0-' + precision));
        //       // order.overrideAvgPrice = Number(this.decimalPipe.transform(order.overrideAvgPrice, '1.0-' + precision));
        //     }
        //   }
        // }

        exchangeOverride.orders.push(order);

        // if (record && record.orders && record.orders.length > 0) {
        //   const currentContract = this.getContract(record.orders[0]);
        //   if (currentContract) {
        //     return currentContract && currentContract.pricePrecision.toString().includes('.')
        //       ? currentContract.pricePrecision.toString().split(".")[1].length : 0;
        //   }
        // }
        // //fix rnd aps issue
        // const currentContract = this.getContract(order);
        // if (currentContract) {
        //   const precision = currentContract && currentContract.pricePrecision.toString().includes('.')
        //     ? currentContract.pricePrecision.toString().split(".")[1].length : 0;
        //   order.avgRndPrice = parseFloat(order.avgRndPrice.toFixed(precision));
        //   order.avgPrice = parseFloat(order.avgPrice.toFixed(precision));
        //   order.overrideAvgPrice = parseFloat(order.overrideAvgPrice.toFixed(precision));
        //   order.avgPriceResidual = parseFloat(order.avgPriceResidual.toFixed(precision));
        // }
      });
      // exchangeOverrides.forEach(exchangeOverride => {
      //   if (exchangeOverride.overridePrice == 0 && exchangeOverride.orders[0].overrideAvgPrice >= 0)
      //     exchangeOverride.overridePrice = exchangeOverride.orders[0].overrideAvgPrice;
      // });
    }
    // else {
    exchangeOverrides.forEach(exchangeOverride => {
      if (exchangeOverride.overridePrice == 0) {
        const overrideValue = exchangeOverride.orders[0].overrideAvgPrice;
        if (overrideValue > 0) {
          exchangeOverride.overridePrice = overrideValue;
        } else if (overrideValue == AppConfigService.OVERRIDE_TO_ZERO) {
          exchangeOverride.overridePrice = 0;
        } else {
          exchangeOverride.overridePrice = undefined;
        }
      } else if (this.appConfigService.clearingApsOverrideDefaultEmpty && defaultOverrideUndefined)
        exchangeOverride.overridePrice = undefined;
    });
    // }


    this.formRecord = {exchangeOverrides: exchangeOverrides};
  }

  save() {
    this.formLoading = true;
    this.allocationService.exchangeApsOverride(this.formRecord.exchangeOverrides).subscribe(validation => {
      if (validation.success) {
        this.onSavedForm.emit({taskId: validation.item, formRecord: [...this.formRecord.exchangeOverrides]});
        this.closeDialogForm();
      } else {
        this.errorMessage(validation.message);
      }
      this.formLoading = false;
    });
  }

  private optimizeAps() {
    this.formLoading = true;
    this.allocationService.exchangeApsOverrideOptimizeResidual(this.significantOrders[0].id).subscribe(apiValidation => {
      if (apiValidation.success) {
        this.loadExchangeOverrides(apiValidation.item, undefined, false);
        this.refreshFieldData();
      } else {
        this.errorMessage(apiValidation.message);
      }
      this.formLoading = false;
    })
  }

  private resetForm() {
    this.loadExchangeOverrides(this.significantOrders);
    this.refreshFieldData();
  }

  private getGlobalResidual() {
    let residual: number = 0;
    let currentCurrency = '';
    if (this.contracts) {
      this.formRecord.exchangeOverrides.forEach(exchangeOverride => {
        const order: Order = exchangeOverride.orders[0];
        let currentContract = undefined;

        if (this.contracts && this.formRecord && this.formRecord.exchangeOverrides.length > 0) {
          currentContract = this.getContract(order);
          if (currentContract) {
            // console.log("-------> ### currentContract " + JSON.stringify(currentContract));
            currentCurrency = currentContract.currency;
            if (this.currencies) {
              const currencyField = this.currencies ? this.currencies.find(value => value.id.toUpperCase() === currentCurrency.toUpperCase()) : undefined;
              // console.log("-------> ### currencyField " + JSON.stringify(currencyField));
              if (currencyField)
                currentCurrency = currencyField.value;
            }
          }
        }
        let pointValue: number = 0;
        if (currentContract) {
          pointValue = currentContract.tickValue / currentContract.pricePrecision;
        }

        const sideSign: number = order.side == Side.BUY ? -1 : 1;

        let overridePrice: number = exchangeOverride.overridePrice && !isNaN(exchangeOverride.overridePrice) ? Number(exchangeOverride.overridePrice) : 0;
        if (overridePrice == 0 && order.overrideAvgPrice && !isNaN(order.overrideAvgPrice)
          && order.overrideAvgPrice != 0
          && order.overrideAvgPrice != AppConfigService.NO_OVERRIDE_APS_VALUE) {
          if (order.overrideAvgPrice == AppConfigService.OVERRIDE_TO_ZERO) {
            overridePrice = 0;
          } else {
            overridePrice = order.overrideAvgPrice;
          }
        }

        const totalVolume = exchangeOverride.orders.reduce((previousValue, currentValue) => previousValue + currentValue.volume, 0);
        if (overridePrice != 0) {
          residual += (order.avgPrice - overridePrice) * totalVolume * pointValue * sideSign;
        } else {
          residual = 0;
        }
      });
    }
    const iconClass: string = 'form-info-' + (residual == 0 ? 'yellow' : (residual > 0 ? 'green' : 'red'));
    return '<i class="' + iconClass + '">' + this.decimalPipe.transform(residual, '1.0-2') + ' ' + currentCurrency + '</i>';
    // Number(residual).toLocaleString('UK', {maximumSignificantDigits: 2})
  }

  private getContract(order: Order) {
    const contractIdPart = order.exchangeCode + '-' + order.contractCode + '-' + (order.strike != 0 ? 'O' : 'F');

    // console.log("------> "+contractIdPart)
    return this.contracts.find(contract => contract.id.startsWith(contractIdPart));
  }

}
